export const CATEGORIE_PARENT = 'categorie-parent'; // resource: categorie enfant; relatedObject: categorie parente
export const GOUVERNANCE = 'gouvernance'; // resource: structure; relatedObject: personne
export const LAUREAT = 'laureat'; // resource: prix; relatedObject: personne, structure, projet
export const PERSONNE_CATEGORIE = 'personne-categorie';
export const PERSONNE_TERME = 'personne-terme';
export const PRIX_CATEGORIE = 'prix-categorie';
export const PRIX_TERME = 'prix-terme';
export const PRIX_PORTEUR = 'prix-porteur';
export const PROJET_CONTACT = 'projet-contact';
export const PROJET_CATEGORIE = 'projet-categorie';
export const PROJET_PARTICIPATION = 'projet-participation';
export const PROJET_TERME = 'projet-terme';
export const STRUCTURE_CATEGORIE = 'structure-categorie';
export const STRUCTURE_CATEGORIE_JURIDIQUE = 'structure-categorie-juridique';
export const STRUCTURE_INTERNE = 'structure-interne';
export const STRUCTURE_PREDECESSEUR = 'structure-predecesseur';
export const STRUCTURE_REFERENT_MESR = 'referent-mesr';
export const STRUCTURE_TERME = 'structure-terme';
export const STRUCTURE_TUTELLE = 'structure-tutelle';
export const TERME_CATEGORIE = 'terme-categorie';
export const TERME_PARENT = 'terme-parent'; // resource: terme enfant; relatedObject: terme parent
